'use strict';

module.exports = paragraph;

function paragraph(node) {
  return this.all(node).join('');
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/paragraph.js
// module id = 807
// module chunks = 168707334958949